import { ScanBarcode } from "lucide-react";

const NavbarScanner = ({ onScanClick }) => {
  return (
    <button
      onClick={onScanClick}
      className="
        p-3 rounded-full 
        bg-white 
        text-[#1E40AF] 
        flex items-center justify-center
        transform transition 
        duration-300 ease-in-out
        hover:scale-110 
        hover:shadow-lg 
        hover:bg-[#BFDBFE]
        active:scale-95
      "
    >
      <ScanBarcode className="w-8 h-8" />
    </button>
  );
};

export default NavbarScanner;
